// Header.js
import React from 'react';
import ssaltcoin from '../assets/ssaltcoin.png';
import Web3Login from './Web3Login';
import { useCoin } from '../CoinContext';

function Header() {
  const { currentPoints } = useCoin();

  return (
    <div style={{
      width: '100%',
      maxWidth: '430px',
      minWidth: 0,
      boxSizing: 'border-box',
      height: 56,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: 'rgba(248, 252, 255, 0.86)',
      padding: '0 12px',
      borderBottom: '1px solid #eee',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 20,
      overflow: 'hidden'
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={ssaltcoin} alt="PetCoin" width={28} height={28} style={{ marginRight: 8 }} />
        <span style={{ fontWeight: 700, color: '#333', fontSize: 20 }}>
          {Number(currentPoints).toLocaleString()}
        </span>
      </div>
      <Web3Login />
    </div>
  );
}

export default Header;
